import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomIcon } from '@app/shared/models/custom-icon';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);


  readonly basePath = './assets/icons';

  registerIcons(icons: CustomIcon[] ): void {
    icons.forEach(icon => this.registerIcon(icon.name, `${this.basePath}/${icon.url}`));
  }

  registerIcon(name: string, url: string): void {
    this.iconRegistry.addSvgIcon(name, this.sanitizer.bypassSecurityTrustResourceUrl(url));
  }

}
